import React, { useEffect } from 'react';
import Meeting from '../../components/employees/Meeting';


const MeetingPage = () => {
   useEffect(() => {
        document.body.id = "meeting-004";
      }, []);
  return (
    <div className='commom-001'>
       <Meeting />
    </div>
  );
};

export default MeetingPage;
